// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__JdokK","box":"WorkspacesBox_box__2a4Uh","node":"WorkspacesBox_node__1d0qX"};